















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HeaderLink extends Vue {
  @Prop({ default: false }) active: boolean;
}
